import React, {useEffect, useMemo, useRef, useState} from 'react';
import styled from 'styled-components';
import {createPortal} from 'react-dom';
import {
    Announcements,
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragStartEvent,
    DragOverlay,
    DragMoveEvent,
    DragEndEvent,
    DragOverEvent,
    MeasuringStrategy,
    DropAnimation,
    defaultDropAnimation,
    Modifier,
} from '@dnd-kit/core';
import {
    SortableContext,
    arrayMove,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import SortableTreeItem from './SortableTreeItem'

const Container = styled.div`
    
`

const measuring = {
    droppable: {
        strategy: MeasuringStrategy.Always,
    },
};

const dropAnimation = {
    ...defaultDropAnimation,
    dragSourceOpacity: 0.5,
};

const SortableTree = props => {
    const {
        id,
        tree,
        indentationWidth = 50
    } = props
    console.log('[SortableTree]',{id, tree})
    const debug = true
    const ids = tree.map(treeItem => treeItem['id'])

    const [activeId, setActiveId] = React.useState(null);
    const [overId, setOverId] = React.useState(null);
    const [offsetLeft, setOffsetLeft] = React.useState(0);
    const [currentPosition, setCurrentPosition] = useState({parentId: null, overId});


    const announcements = {
        onDragStart(id) {
            return `Picked up ${id}.`;
        },
        // onDragMove(id, overId) {
        //     return console.log('onDragMove', id, overId);
        // },
        onDragOver(id, overId) {
            return console.log('onDragOver', id, overId);
        },
        onDragEnd(id, overId) {
            return console.log('onDragEnd', id, overId);
        },
        onDragCancel(id) {
            return `Moving was cancelled. ${id} was dropped in its original position.`;
        },
    };

    function handleDragStart({active: {id: activeId}}) {
        setActiveId(activeId);
        setOverId(activeId);
    
        const activeItem = tree.find(({id}) => id === activeId);
    
        if (activeItem) {
            setCurrentPosition({
                parentId: activeItem.parentId,
                overId: activeId,
            });
        }
    
        document.body.style.setProperty('cursor', 'grabbing');
    }
    
    function handleDragMove({delta}) {
        setOffsetLeft(delta.x);
    }
    
    function handleDragOver({over}) {
        setOverId(over?.id ?? null);
    }

    
    function handleDragEnd({active, over}) {
        
    }
    
    function handleDragCancel() {
        resetState();
    }
    
    function resetState() {
        setOverId(null);
        setActiveId(null);
        setOffsetLeft(0);
        setCurrentPosition(null);
    
        document.body.style.setProperty('cursor', '');
    }


    
    return (
        <Container>
            <DndContext
                announcements={announcements}
                collisionDetection={closestCenter}
                measuring={measuring}
                onDragStart={handleDragStart}
                onDragMove={handleDragMove}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}>

                <SortableContext items={ids} strategy={verticalListSortingStrategy}>
                    {tree.map(treeItem => (
                        <SortableTreeItem key={treeItem['id']} id={treeItem['id']} value={treeItem['id']}>
                            {treeItem['block']}
                        </SortableTreeItem>
                    ))}
                </SortableContext>

            </DndContext>
            
            
        </Container>
    )
}

export default SortableTree;